import {usePipelineProjectLocator} from '../../../../../../hooks/pipeline'

export function useBranchesArg() {
  const projectLocator = usePipelineProjectLocator()

  return {
    projectLocator,
    locator: 'policy:ALL_BRANCHES',
    fields: 'branch(name,default)',
  }
}
